import React from 'react'
import { IBadgeProps } from './interfaces'
import { Tooltip } from 'antd'
import { StatusType } from '../../enums/status-type'
import { titleCase } from '../../_utils/utils'
import './status-badge.scss'
import {
    CarryOutOutlined,
    CheckCircleOutlined,
    CloseSquareOutlined,
    FormOutlined,
    PauseCircleOutlined,
    PlayCircleOutlined,
    WarningOutlined,
} from '@ant-design/icons'

/*
    "expanded" view forces hidden tooltip
    and displays the status text to the right
    of the badge
 */
interface IProps extends IBadgeProps {
    status: string
    expanded?: boolean
}

export const AppMessageStatusBadge: React.FC<IProps> = (props) => {
    const hideTooltip = props.hideTooltip || props.expanded

    let text = props.status
    let icon = <CarryOutOutlined />

    switch (props.status) {
        case StatusType.COMPLETED.name:
            text = 'COMPLETED'
            icon = <CheckCircleOutlined />
            break
        case StatusType.ACTIVE.name:
            text = 'RUNNING'
            icon = <PlayCircleOutlined />
            break
        case StatusType.PAUSED.name:
            text = 'PAUSED'
            icon = <PauseCircleOutlined />
            break
        case StatusType.CANCELLED.name:
            text = 'CANCELLED'
            icon = <CloseSquareOutlined />
            break
        case StatusType.DISABLED.name:
            text = 'DISABLED'
            icon = <WarningOutlined />
            break
        case StatusType.DRAFT.name:
            icon = <FormOutlined />
            break
        default:
            break
    }

    const badge = <span className={`status-icon status-${text}`}>{icon}</span>

    return (
        <span className="status-badge app-message-status-badge">
            {hideTooltip ? (
                !props.expanded ? (
                    badge
                ) : (
                    <>
                        {badge}
                        <span className="status-name">{titleCase(text)}</span>
                    </>
                )
            ) : (
                <Tooltip title={props.tooltip || text}>{badge}</Tooltip>
            )}
        </span>
    )
}
